<div class="transaction-item bg-neutral-950 rounded-sm p-1.5 cursor-pointer min-h-24">
  <div class="tli-header flex flex-col">
    <span class="text-neutral-400">{{ transaction.date | date }}</span>
    <span class="text-xl">{{ transaction.reason }}</span>
  </div>

  <div class="tli-attachments flex flex-row items-center">
    @if (transaction.notes) {
      <div class="h-6 w-6 cursor-pointer mt-auto" [pTooltip]="transaction.notes">
        <mat-icon>info</mat-icon>
      </div>
    }

    @for (f of transaction.files; track f) {
      <div
        class="h-6 w-6 cursor-pointer mt-auto"
        [pTooltip]="f.fileName"
        (click)="$event.stopPropagation(); openDocument(transaction._id, f.fileName)"
      >
        @if (f.mimeType == 'application/pdf') {
          <mat-icon>description</mat-icon>
        }
        @if (f.mimeType != 'application/pdf') {
          <mat-icon>image</mat-icon>
        }
      </div>
    }
  </div>

  <div class="tli-userevent flex flex-col justify-around">
  @if (transaction.user) {
    @if (loadingUser()) {
      <p-skeleton class="mt-3" height="2rem" />
    } @else {
      <span class="tli-user flex flex-row gap-2 items-center">
        <mat-icon>person</mat-icon>
        <span>{{ user()?.fullname ?? transaction.user }}</span>
      </span>
    }
  }

  @if (transaction.event && showEvent) {
    @if (loadingEvent()) {
      <p-skeleton class="mt-3" height="2rem" />
    } @else {
      <span class="tli-event flex flex-row gap-2 items-center">
        <mat-icon>event</mat-icon>
        <span>{{ event()?.name ?? transaction.event }}</span>
      </span>
    }
  }
  </div>

  @if (transaction.pending) {
    <span class="tli-pending desktop text-3xl text-center mt-auto mb-auto">{{
      'internal.finances.transaction.pending' | translate
    }}</span>

    <span class="tli-pending mobile text-xl text-center mt-auto mb-auto">
      <mat-icon>money_off</mat-icon>
    </span>
  }

  <span
    class="tli-amount desktop text-3xl text-end mt-auto mb-auto"
    [class.negative]="!transaction.isIncome"
  >
    {{ transaction.isIncome ? '' : '-' }}
    {{ transaction.amount.toFixed(2) | mask: 'separator' : { thousandSeparator: ',' } }}€
  </span>

  <span
    class="tli-amount mobile text-xl text-end mt-auto mb-auto"
    [class.negative]="!transaction.isIncome"
  >
    {{ transaction.isIncome ? '' : '-' }}
    {{ transaction.amount.toFixed(2) | mask: 'separator' : { thousandSeparator: ',' } }}€
  </span>

  <span class="tli-edit justify-evenly flex flex-col items-end">
    @if (showEditButton) {
      <p-button
        [rounded]="true"
        [text]="true"
        (onClick)="$event.stopPropagation(); this.edit.emit()"
      >
        <mat-icon color="white">edit</mat-icon>
      </p-button>
    }
    @if (!showEditButton) {
      <div style="width: 40px; height: 40px"></div>
    }
    @if (showDeleteButton) {
      <p-button
        [rounded]="true"
        [text]="true"
        severity="danger"
        (onClick)="$event.stopPropagation(); this.delete.emit()"
      >
        <mat-icon>delete</mat-icon>
      </p-button>
    }
    @if (!showDeleteButton) {
      <div style="width: 40px; height: 40px"></div>
    }
  </span>
</div>
